<div class="pickup-chat-fab">
  <button
    type="button"
    class="pickup-chat-button"
    aria-label="Nachrichten öffnen"
    (click)="open()">
    <i class="pi pi-comments"></i>
  </button>
  @if (unreadTotal() > 0) {
    <span class="pickup-chat-badge">{{ unreadTotal() }}</span>
  }
</div>

<p-drawer
  [(visible)]="visible"
  position="bottom"
  styleClass="pickup-chat-drawer"
  [style]="{ height: '80dvh', 'max-height': '80dvh' }"
  [showCloseIcon]="false">
  <ng-template #headless>
    <div class="chat-shell">
    @if (panel === 'list') {
      <header class="chat-header">
        <div>
          <h2>Nachrichten</h2>
          <span>{{ unreadTotal() }} ungelesen</span>
        </div>
        <div class="chat-header-actions">
          <p-button label="Neuer Chat" [text]="true" size="small" (onClick)="showNewChat()"></p-button>
          <p-button icon="pi pi-times" [rounded]="true" [text]="true" ariaLabel="Schließen" (onClick)="close()"></p-button>
        </div>
      </header>

      <div class="chat-list">
        @if (loading) {
          <div class="empty-state">
            <p-progressSpinner styleClass="small-spinner" strokeWidth="4"></p-progressSpinner>
          </div>
        } @else if (chats.length === 0) {
          <div class="empty-state">
            <i class="pi pi-comments"></i>
            <h3>Noch keine Chats</h3>
            <span>Starte eine Unterhaltung mit Mitarbeitenden.</span>
            <p-button label="Chat starten" icon="pi pi-plus" (onClick)="showNewChat()"></p-button>
          </div>
        } @else {
          @for (chat of chats; track chat.id) {
            <button type="button" class="chat-list-item" (click)="selectChat(chat)">
              <p-avatar
                [label]="chat.type === 'group' ? '' : (firstOtherUser(chat) | avatarLabel)"
                [icon]="chat.type === 'group' ? 'pi pi-users' : undefined"
                shape="circle">
              </p-avatar>
              <div class="chat-list-text">
                <div class="chat-list-title-row">
                  <span class="chat-list-title">{{ chatTitle(chat) }}</span>
                  @if (lastMessage(chat)) {
                    <span class="chat-list-date">{{ messageDate(lastMessage(chat)) | date : 'dd.MM. HH:mm' }}</span>
                  }
                </div>
                <div class="chat-list-preview-row">
                  <span class="chat-list-preview">{{ lastMessagePreview(chat) }}</span>
                  @if (unreadCount(chat) > 0) {
                    <p-badge [value]="unreadCount(chat).toString()" severity="danger"></p-badge>
                  }
                  <i class="pi pi-chevron-right chat-list-chevron"></i>
                </div>
              </div>
            </button>
          }
        }
      </div>
    }

    @if (panel === 'new') {
      <header class="chat-header">
        <div class="chat-title-with-back">
          <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" ariaLabel="Zurück" (onClick)="showList()"></p-button>
          <div>
            <h2>Neuer Chat</h2>
            <span>Eine oder mehrere Personen auswählen</span>
          </div>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" ariaLabel="Schließen" (onClick)="close()"></p-button>
      </header>

      <form class="new-chat-panel" (ngSubmit)="createChat()" [formGroup]="newChatForm">
        <p-floatlabel>
          <p-autoComplete
            inputId="pickup-chat-recipients"
            inputStyleClass="w-100"
            class="w-100"
            formControlName="recipients"
            [suggestions]="users"
            (completeMethod)="filterUsers($event)"
            field="first_name"
            [appendTo]="'body'"
            [baseZIndex]="12000"
            scrollHeight="14rem"
            [multiple]="true">
            <ng-template let-user pTemplate="item">
              <div class="user-option">
                <p-avatar [label]="user | avatarLabel" shape="circle"></p-avatar>
                <span>{{ userName(user) }}</span>
              </div>
            </ng-template>
            <ng-template let-user pTemplate="selectedItem">
              <span>{{ userName(user) }}</span>
            </ng-template>
          </p-autoComplete>
          <label for="pickup-chat-recipients">Empfänger</label>
        </p-floatlabel>
        <p-button
          type="submit"
          label="Chat starten"
          icon="pi pi-plus"
          styleClass="w-100"
          [loading]="sending"
          [disabled]="newChatForm.invalid || sending">
        </p-button>
      </form>
    }

    @if (panel === 'chat' && selectedChat) {
      <header class="chat-header">
        <div class="chat-title-with-back">
          <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" ariaLabel="Zurück" (onClick)="showList()"></p-button>
          <div>
            <h2>{{ chatTitle(selectedChat) }}</h2>
            @if (selectedChat.type === 'group') {
            <span>{{ sortedMessages(selectedChat).length }} Nachrichten</span>
            }
          </div>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" ariaLabel="Schließen" (onClick)="close()"></p-button>
      </header>

      <div class="chat-messages">
        @if (sortedMessages(selectedChat).length === 0) {
          <div class="empty-state">
            <i class="pi pi-comment"></i>
            <span>Schreibe die erste Nachricht.</span>
          </div>
        }

        @for (message of sortedMessages(selectedChat); track message.id; let index = $index) {
          @if (showDateSeparator(message, selectedChat, index)) {
            <div class="date-separator">{{ messageDate(message) | date : 'dd.MM.yyyy' }}</div>
          }
          <div class="message-row" [class.own]="isOwnMessage(message)">
            <div class="message-bubble">
              @if (selectedChat.type === 'group' && !isOwnMessage(message)) {
                <span class="message-author">{{ userName(message.users_permissions_user) }}</span>
              }
              <span class="message-body">{{ message.body }}</span>
              <span class="message-date">
                {{ messageDate(message) | date : 'HH:mm' }}
                @if (messageReadState(message, selectedChat); as readState) {
                  <span class="read-state" [class.read]="readState === 'read'"
                    [attr.aria-label]="readState === 'read' ? 'Gelesen' : 'Gesendet'">
                  </span>
                }
              </span>
            </div>
          </div>
        }
        <div #pickupMessagesEnd></div>
      </div>

      <form class="reply-form" (ngSubmit)="sendMessage()" [formGroup]="replyForm">
        <textarea
          pTextarea
          formControlName="message"
          rows="2"
          placeholder="Nachricht schreiben"
          class="reply-input"
          (keydown)="handleReplyKeydown($event)">
        </textarea>
        <p-button
          type="submit"
          icon="pi pi-send"
          [rounded]="true"
          [loading]="sending"
          [disabled]="replyForm.invalid || sending">
        </p-button>
      </form>
    }
    </div>
  </ng-template>
</p-drawer>
